<template>
  <q-card
    class="card q-mx-auto"
    style="max-width: 756px; width: 100%"
    :style="cssVars"
  >
    <q-scroll-area
      :thumb-style="{
        background: '#162c479c',
        opacity: 1,
        width: '8px',
        height: '8px',
        borderRadius: '20px',
      }"
      style="width: 756px; height: 100%"
    >
      <div class="row justify-between">
        <div>
          <q-tabs v-model="tab" inline-label>
            <q-tab
              :name="tab.name"
              no-caps
              v-for="(tab, i) in tabs.filter((t) => !t.disable)"
              :key="i"
              :disable="tab.disable"
            >
              <div class="row items-center text-accent">
                <q-icon :name="tab.icon" size="xs"> </q-icon>
                <span class="tabTitle q-ml-sm"> {{ tab.label }}</span>
              </div>
            </q-tab>
          </q-tabs>
        </div>
        <q-btn icon="mdi-close" flat round @click="closeDialog" class="q-mr-sm">
        </q-btn>
      </div>
      <div class="row">
        <q-tab-panels v-model="tab" animated class="full-width">
          <q-tab-panel name="goalBuilder" class="q-pa-none">
            <!--GOAL BUILDER-->
            <goal-builder-form
              v-if="selectedData != null"
              :selectedData="selectedData"
              :outcomeColor="outcomeColor"
              @closeForm="closeDialog"
            ></goal-builder-form>
          </q-tab-panel>
        </q-tab-panels>
      </div>
    </q-scroll-area>
  </q-card>
</template>

<script>
import { mapGetters } from "vuex";
import GoalBuilderForm from "@/components/goalBuilder/workspaceGoalBuilder/goalBuilderForm/goalBuilderForm.vue";
export default {
  components: {
    GoalBuilderForm,
  },
  computed: {
    ...mapGetters({
      currentUserData: "auth/currentUserData",
      selectedData: "sources/data/selectedData",
    }),
    cssVars() {
      return {
        "--outcome-color": this.outcomeColor,
        "--secondary-color": this.secondaryColor,
      };
    },
  },
  props: {
    outcomeColor: {
      type: String,
      default: "#162C47",
    },
    outcomeColorSecondary: {
      type: String,
      default: "#162C47",
    },
  },
  mounted() {
    this.init();
  },
  data: () => ({
    tab: "goalBuilder",
    tabs: [
      {
        sort: 1,
        name: "goalBuilder",
        label: "Goal Builder",
        icon: "mdi-wrench",
        disable: false,
      },
    ],
  }),
  methods: {
    async init() {
      await this.$store.dispatch("sources/data/loadBySourceID", {
        id: this.$route.params.sourceID,
        currentGoal: true,
      });
      if(this.selectedData && this.selectedData.goalBuilderGoal)
      {
        await this.$store.dispatch("goals/loadByIDWithEmissionsFactor", {
          id: this.selectedData.goalBuilderGoal.id,
          year: this.selectedData.date.split("-")[0],
        });
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  height: 550px;
}

.tabTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}
</style>
